import config from './config';

export function throttle(func, delay = config.throttleTimeout) {
    let timer;

    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(context, args), delay);
    }
}

export function debounce(func, delay) {
    let inDebounce;

    return function() {
        const args = arguments;
        const context = this;
        if (!inDebounce) {
            func.apply(context, args);
            inDebounce = true;
            setTimeout(() => inDebounce = false, delay)
        }
    }
}

export function declOfNum(number, titles) {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
}

export function searchStringToArray(str) {
    if (!str) return [];
    str = str.charAt(0) === '?' ? str.slice(1) : str;

    return $.map(str.split('&'), function(item){
        let splitArr = item.split('=');

        return {
            name: decodeURIComponent(splitArr[0]),
            value: decodeURIComponent(splitArr[1])
        }
    });
}

export function serializeString(str) {
    let arr = searchStringToArray(str);
    return $.param(arr);
}


export function changeUrlState({ search = location.search, hash = location.hash }) {
    return history.pushState(null, null, location.origin + location.pathname + search + hash);
}

export function generateId() {
    return Date.now() + Math.random().toString().slice(2);
}

export function openFullScreen(element) {
    if (element.requestFullscreen) {
        element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
    }
}

export function closeFullScreen() {
    if (document.cancelFullScreen) {
        document.cancelFullScreen();
    } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
    }
}

export function isSupportFullScreenApi(element) {
    return !!(element.requestFullscreen || element.mozRequestFullScreen || element.webkitRequestFullscreen);
}



// WEBPACK FOOTER //
// ./utils.js